export default __webpack_public_path__ + "static/media/watch.9ad5b81e.jpg";